"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[833],{

/***/ 80833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ side_by_side_title_paragraph_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js + 1 modules
var side_by_side_text_and_asset = __webpack_require__(25641);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-title-paragraph/side-by-side-title-paragraph-component.scss.js


var StyledSideBySideTitleParagraphComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eo7wzv60"
})("&.side-by-side-title-paragraph-component{.side-by-side-text-and-asset{max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;.side-by-side-content{.full-paragraph-component-wrapper{min-width:", function(param) {
    var titleMinWidth = param.titleMinWidth;
    return titleMinWidth;
}, ";}.image-wrapper{align-self:", function(param) {
    var paragraphVerticalAlignment = param.paragraphVerticalAlignment;
    return paragraphVerticalAlignment;
}, ";}}}}");

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-title-paragraph/side-by-side-title-paragraph-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var SideBySideTitleParagraphComponent = function(props) {
    var titleProps = props.titleProps, paragraphProps = props.paragraphProps, titleAdvancedProps = props.titleAdvancedProps, paragraphAdvancedProps = props.paragraphAdvancedProps, paragraphVerticalAlignment = props.paragraphVerticalAlignment, restProps = _object_without_properties(props, [
        "titleProps",
        "paragraphProps",
        "titleAdvancedProps",
        "paragraphAdvancedProps",
        "paragraphVerticalAlignment"
    ]);
    var titlePropsIncludingAdvanced = _object_spread({}, titleProps, titleAdvancedProps);
    var paragraphPropsIncludingAdvanced = _object_spread_props(_object_spread({}, paragraphProps, paragraphAdvancedProps), {
        topic: "",
        title: ""
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBySideTitleParagraphComponent, {
        paragraphVerticalAlignment: paragraphVerticalAlignment,
        titleMinWidth: titleAdvancedProps === null || titleAdvancedProps === void 0 ? void 0 : titleAdvancedProps.titleMinWidth,
        className: "side-by-side-title-paragraph-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, _object_spread({
            paragraphVerticalAlignment: "top",
            replaceTextComponent: title/* default */.Z,
            replaceTextComponentProps: titlePropsIncludingAdvanced,
            replaceAssetComponent: full_paragraph/* default */.ZP,
            replaceAssetComponentProps: paragraphPropsIncludingAdvanced
        }, restProps))
    });
};
/* harmony default export */ var side_by_side_title_paragraph_component = (SideBySideTitleParagraphComponent);
SideBySideTitleParagraphComponent.defaultProps = {
    paddingTop: "48px",
    paddingBottom: "48px",
    fullParagraph: {},
    titleProps: title/* default.defaultProps */.Z.defaultProps,
    paragraphProps: {
        body: "Boost your team’s alignment, efficiency, and productivity by customizing any workflow to fit your needs."
    },
    alignToLogo: true
};


/***/ })

}]);